/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fine_Heavy_Mallard_ComfortInputs */

const fr_fine_heavy_mallard_comfort = /** @type {(inputs: Fine_Heavy_Mallard_ComfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppression role`)
};

/**

* @param {Fine_Heavy_Mallard_ComfortInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fine_heavy_mallard_comfort = /** @type {((inputs?: Fine_Heavy_Mallard_ComfortInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fine_Heavy_Mallard_ComfortInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fine_heavy_mallard_comfort(inputs)
});